import { useTranslation } from "react-i18next";

export default function Header({ name, registered, view, setView }) {
  const { t } = useTranslation();

  return (
    <h1 className="text-2xl text-center mb-6 font-bold bg-clip-text text-transparent bg-gradient-to-r from-yellow-300 via-green-400 to-blue-300">
      <span className={registered ? "hidden" : ""}>
        {t("description.defaultHeader")}
      </span>
      <span className={registered ? "" : "hidden"}>
        <span>{name + t("description.loginHeader")}</span>
        <a
          href="#"
          onClick={() => setView(view === "years" ? "weeks" : "years")}
          className="border-b-2 border-green-500 border-opacity-25 hover:border-opacity-50"
        >
          {view === "years"
            ? t("description.loginHeaderYear")
            : t("description.loginHeaderWeek")}
          {t("description.loginHeaderBlock")}
        </a>
      </span>
    </h1>
  );
}
